import React from 'react'
import i18n from 'i18n-js'

import './Footer.scss'

const Footer = () => {
    return <footer className="Footer container">
        <p>{i18n.t('footer_1')}</p>
        <p>{i18n.t('footer_2')}</p>
    </footer>
}

export default Footer